"use client";
import React from "react";
import DesktopHeaderView from "./_components/desktop-view";
import { Navbar_Menu_List } from "@/lib/dto/header/menu";
// import TopNotch from "../top-notch/page";
import MobileNav from "./_components/mobile-nav";

function Header() {
  return (
    <div className="fixed w-full z-100">
      {/* <TopNotch /> */}
      <DesktopHeaderView menu={Navbar_Menu_List} />
      <MobileNav />
    </div>
  );
}

export default Header;
